export default {
    ACCOUNT_BALANCE_REPORT_COLUMN_TITLE_REMAINS_EURO: "Евро",
    ACCOUNT_BALANCE_REPORT_COLUMN_TITLE_REMAINS_RUR: "Рубли",
    ACCOUNT_BALANCE_REPORT_COLUMN_TITLE_REMAINS_RUR_EQ: "Экв. Рубли",
    ACCOUNT_BALANCE_REPORT_COLUMN_TITLE_REMAINS_USD: "Доллары",
    show_cell_inspector: "Инспектор ячейки",
    Cancel: "Отмена",
    Error: "Ошибка",
    Event: "Событие",
    No: "Нет",
    RATE_EXPENSES_REQUEST_SCHEME_ACTUAL: "Схема работы (факт)",
    RATE_EXPENSES_REQUEST_SCHEME_EXPECTED: "Схема работы (план)",
    Settings: "Настройки",
    TRANSFER_UNIT_ROUTE: "Маршрут",
    Tasks: "Задачи",
    Warning: "Предупреждение",
    Yes: "Да",
    disable_reason: "Заполните предыдущую дату!",
    "You should add at least one contact person": "Необходимо добавить хотя бы одно контактное лицо",
    account_currency_is_not_specified:
        "Валюта счета не указана<br>Перерасчет на мультивалютных счетах не будет произведен",
    account_operations_modal_title: "Операции счета",
    currency_account_operations_modal_title: "Карточка валютного счета",
    add: "Добавить",
    add_company_link: "Выберите нового контрагента",
    add_invoice_button_text__payment_order_form: "Добавить счет",
    add_new_role_placeholder: "Добавить новую роль",
    add_tab_invoice_form: "Добавить услугу",
    add_transfer_arrival_point: "Добавить точку маршрута",
    add_transfer_button_text__transfer_unit_form: "Добавить плечо",
    add_transfer_link_button_text__transfer_unit_form: "Связать с плечом",
    add_transfer_units_to_forwarding: "Добавить грузовые единицы",
    add_units_invoice_form: "Добавить позиции",
    add_user_button_text: "Добавить пользователя",
    add_warehouse_link: "Выберите новую точку маршрута",
    add_order_fin_operation: "Добавить фин. операцию данного заказа",
    add_order_fin_operation_unit_and_order_doc_link: "Добавить документы фин операции данного заказа",
    add_fin_operation: "Добавить фин. операцию",
    add_fin_operation_unit_and_order_doc_link: "Добавить документы фин операции",
    admi_modal_title: "Администрирование",
    admin_item_title_menu: "Меню",
    admin_item_title_roles: "Роли",
    admin_item_title_users: "Пользователи",
    all: "Все",
    all_operaions_must_have_account: "У всех операций должен быть счет",
    all_operations_must_have_one_currency: "Все операции должны быть в одной валюте",
    all_transfer_unit_in_select_row_winodw: "Все",
    are_you_ready_clear_scheme_in_order: "Вы действительно хотите очистить схему?",
    arrival_map_days_1: "День",
    arrival_map_days_2: "Дня",
    arrival_map_days_5: "Дней",
    arrival_map_not_found: "Ничего не найдено",
    arrival_map_vessel: "Судно",
    arrival_map_voyage: "Рейс",
    attach_file_title: "Файл",
    attach_target_title: "Объект",
    back: "Назад",
    before_submit_error: "Ошибка в beforeSubmit",
    validate_error: "Ошибка валидации данных",
    binding_failed_in_a_car_transaction_only_one_link_load_to_one_document:
        "Привязка не выполнена: в автомобильной операции можно привязать только 1 груз к 1 документу.",
    btn_all_text: "Добавить все",
    calc_tax_error_code_100: "Не удалось получить данные по ТН ВЭД коду",
    calc_tax_error_code_110: "Лимит запросов для данного пользователя исчерпан",
    calc_tax_error_code_200: "Информация по данному коду ТН ВЭД не найдена, несуществующий код ТН ВЭД",
    calc_tax_error_code_201: "Необходимо указать вес нетто",
    calc_tax_error_code_210: "Не удалось получить данные по ТН ВЭД коду",
    calc_tax_error_code_220: "На запрошенную дату код не действует",
    calc_tax_error_code_250: "Код страны не найден",
    calendar_item_view_more: "еще ",
    calendar_modal_title: "Календарь",
    cam_photo_item_select: "Выбрать",
    cam_settings_modal_title: "Настройки камеры",
    cam_settings_proporion: "Введите пропорцию снимка, например 16/9",
    cancel_button: "Отмена",
    cant_remove_billed_transaction: "Нельзя удалить операцию, по которой выставлены счета",
    cant_remove_mirror_incoming_invoices: "Нельзя удалить зеркальные счета: {= invoices}",
    cant_remove_orders_with_invoices: "Нельзя удалить заказы, у которых выставлены или внесены счета",
    cfm_all_text: "(Выделить все)",
    change_desktop_wallpapers: "Сменить обои",
    change_operation_unit_order_confirm_choose_order_after_destroy_unit_links: "Связей больше не осталось, продолжить?",
    change_operation_unit_order_error_details_fin_opers_title: "Финансовые операции:",
    change_operation_unit_order_error_details_gtds_title: "Таможенные декларации:",
    change_operation_unit_order_error_details_invoices_at: "от",
    change_operation_unit_order_error_details_invoices_title: "Счета:",
    change_operation_unit_order_error_details_log_doc_opers_title: "Документы логистических операций:",
    change_operation_unit_order_error_details_log_opers_title: "Логистические операции:",
    change_operation_unit_order_error_details_title: "Необходимо отвязать грузовую единицу от:",
    change_operation_unit_order_error_text: "Невозможно отвязать грузовую единицу от этого заказа",
    chat_clear_history_confirm: "Вы действительно хотите удалить эти сообщения?",
    chat_clear_history_confirm_ok_text: "Удалить",
    chat_create_room_name_placeholder: "Наименование группы",
    chat_create_room_selected_1: "участник",
    chat_create_room_selected_2: "участника",
    chat_create_room_selected_5: "участников",
    chat_last_seen_prefix: "Заходил ",
    chat_leave_room_confirm: "Вы действительно хотите покинуть эту группу?",
    chat_leave_room_confirm_ok_text: "Покинуть",
    chat_never_seen: "Не заходил",
    chat_no_last_message_text: "Написать...",
    chat_room: "Комната",
    chat_room_edit_list_clear_history: "Очистить",
    chat_room_edit_list_leave: "Выйти",
    chat_room_edit_list_mute: "Отключить уведомления",
    chat_room_edit_list_unmute: "Включить уведомления",
    chat_room_settings: "Настройки",
    chat_room_settings_title: "Группа: ",
    chat_rooms_create_input_placeholder: "Введите название группы",
    chat_row_room_title: "Чаты: {=table}#{=id}",
    chat_search_counter__not_found: "Нет соответствий",
    chat_search_counter__of: "из",
    chat_search_placeholder: "Поиск",
    chat_select_dialog: "Пожалуйста, выберите диалог",
    chat_unreaded_startup_two_description: "Количество непрочитанных сообщений: {=count}",
    chat_unreaded_startup_two_title: "Новые сообщения",
    chat_user: "Пользователь",
    chat_user_online: "Онлайн",
    chat_you: "Вы",
    choose: "Выбрать",
    choose_access_doc: "Выбрать",
    choose_file_from_device: "Выберите файл",
    choose_gtd: "Выбрать",
    choose_incoming_payment: "Выбрать Полученное ПП/SWIFT",
    choose_order_gtd_form_btn_text: "Выбрать заказ",
    choose_outgoing_payment: "Выбрать Отправленное ПП/SWIFT",
    choose_unit: "Выбрать",
    clear: "Очистить",
    clear_contract_data: "Вы уверены, что хотите обновить записи ({=records_qunatity} шт.)?",
    clear_grid_list: "Сбросить",
    client_gtd_by_year__cleared_count: "Выпущено",
    client_gtd_by_year__conditional_cleared_count: "Условно выпущено",
    client_gtd_by_year__release_for_procured_count: "Выпущено под обеспечение",
    client_gtd_by_year__days_to_clear_avg: "Дней на выпуск",
    client_gtd_by_year__payments_sum: "Итого платежей",
    client_gtd_by_year__recalled_count: "Отозвано",
    client_gtd_by_year__refused_count: "Отказано",
    client_gtd_by_year__total_in_row: "Общий итог",
    client_gtd_by_year__total_row_name: "Общий итог",
    client_gtd_by_year_direction__ex: "Экспорт",
    client_gtd_by_year_direction__im: "Импорт",
    client_gtd_by_year_direction__tt: "Транзит",
    client_gtd_by_year_direction__unknown: "(Без направления)",
    client_gtd_by_year_unknown_gtd_point: "(Без таможни)",
    client_gtd_by_year_unknown_gtd_post: "(Без названия)",
    clipboard_bad_support_copy: "Ваш браузер не поддерживает функцию копирования в буфер обмена",
    clipboard_copy_prompt_text: "Вставьте текст в поле, затем нажмите ОК",
    clone_units_confirm_text_invoice_form: "Добавить все позиции в эту вкладку?",
    close_all_apps: "Закрыть все",
    close_button: "Закрыть",
    column_auto_width: "Автоширина столбца",
    apply_button: "Применить",
    reset_button: "Сбросить",
    column_filter_menu_null_values_title: "Пустые",
    column_filter_menu_common_search_placeholder: "Поиск...",
    column_filter_menu_delimited_search_placeholder: "Поиск по {=uniqueValuesNumber} значениям",
    column_filter_menu_title: "Фильтры:",
    combine_operations: "Сборные грузы",
    company_form_create_point_link: "Создать",
    company_form_select_point: "Выбрать",
    confirm_delete_and_replace_on_double: "Удалить и заменить дубль?",
    confirm_edit_rate_expenses:
        "В случае редактирования котировки данные будут изменены во всех зависящих схемах работы. Вы уверены, что хотите изменить эту котировку?",
    confirm_restore_row: "Вы уверены, что хотите восстановить эту строку?",
    confirm_restore_rows: "Вы уверены, что хотите восстановить эти строки?",
    contextmenu_open_file: "Открыть",
    conversion_rate_is_absent: "Курс конвертации отсутствует",
    copy: "Копировать",
    copy_order_confirmation_text:
        "Копирование информации из запроса может привести к потере уже внесенных данных.<br>Вы уверены, что хотите это сделать?",
    copy_order_data_from_request: "Cкопировать с запроса",
    copy_order_warning_text: "Для копирования данных необходимо выбрать запрос",
    country_name_rus: "Россия",
    create: "Создать",
    create_access_doc: "Создать",
    create_gtd: "Создать",
    create_for_all_invoice_positions: "Cоздать для всех позиций счета",
    create_incoming: "Создать получ. ПП",
    create_incoming_btn_text_transfer_unit_form: "Входящий счет",
    create_incoming_by_fin_operation_btn_text_transfer_doc_form: "Входящий счет (по документам фин. операции)",
    create_incoming_by_fin_operation_btn_text_transfer_unit_form: "Входящий счет (по фин. операции)",
    create_incoming_money_btn_text_transfer_unit_form: "Приход ДС",
    create_incoming_money_by_fin_operation_btn_text_transfer_doc_form: "Приход ДС (по документам фин. операции)",
    create_incoming_money_by_fin_operation_btn_text_transfer_unit_form: "Приход ДС (по фин. операции)",
    create_incoming_payment: "Создать Полученное ПП/SWIFT",
    create_invoice_by_fin_operations_multi_contractors_error: "Нельзя создать счет с разными контрагентами",
    create_invoice_by_fin_operations_multi_payers_error: "Нельзя создать счет с разными плательщиками",
    create_order_by_declaration_gtd_btn_text: "Создать заказ",
    create_outgoing: "Создать отправ. ПП",
    create_outgoing_btn_text_transfer_unit_form: "Исходящий счет",
    create_outgoing_by_fin_operation_btn_text_transfer_doc_form: "Исходящий счет (по документам фин. операции)",
    create_outgoing_by_fin_operation_btn_text_transfer_unit_form: "Исходящий счет (по фин. операции)",
    create_outgoing_money_btn_text_transfer_unit_form: "Расход ДС",
    create_outgoing_money_by_fin_operation_btn_text_transfer_doc_form: "Расход ДС (по документам фин. операции)",
    create_outgoing_money_by_fin_operation_btn_text_transfer_unit_form: "Расход ДС (по фин. операции)",
    create_outgoing_payment: "Создать Отправленное ПП/SWIFT",
    create_report: "Создать отчет",
    create_row: "Создать",
    create_unit: "Создать",
    crm_notification_template:
        "Тип: {= escapeHtml(COMPANY_CRM_EVENT_TYPE_NAME)} - {= timestamp2userdate(EXPECTED_DATE_APPLY)}<br/>Компания: {= escapeHtml( LIST_COMPANY_NAME || EVENTS_LIST_COMPANY_NAME )}<br/>Вид связи: {= escapeHtml( COMPANY_CRM_EVENT_CONNECTION_TYPE_NAME )}<br/>Контактное лицо: {= escapeHtml( LIST_CONTACT_PERSONS_CONTACT_PERSON )}<br/>{= (ROW_OBJECT ? 'Объект: ' + escapeHtml(ROW_OBJECT) : '')}<br/>",
    create_with_selecting_invoice_positions: "Создать с указанием позиций счета",
    crm_notification_title: "Напоминание о событии CRM",
    crm_request_source: "Источник",
    crm_request_status: "Статус",
    crm_request_type: "Вид",
    curator: "Куратор",
    currency_of_order_differs_currency_of_account:
        "Валюта платежа отличается от валюты счета<br>При выборе платежа в валюте, отличающейся от валюты счета,<br>необходимо задать курс конверсии на день оплаты",
    current_transfer_unit_in_select_row_winodw: "В этом месте",
    cyrillic_chars_were_replaced_with_latin: "Произведена замена знаков кириллицы {=replacedChars} на латиницу",
    data_changes_log: "Журнал изменений",
    date_repeat_every_day: "Каждый день",
    date_repeat_every_month: "Каждый месяц",
    date_repeat_every_week: "Каждую неделю",
    date_repeat_every_weekdays: "По будням",
    date_repeat_every_year: "Каждый год",
    date_repeat_no_select: "Не выбрано",
    debit_or_credit_must_be_more_then_zero: "Необходимо заполнить дебет и кредит хотя бы двух операций",
    default_confirm_window_title: "Подтвердите действие",
    delete: "Удалить",
    delete_cell: "Очистить ячейку",
    delete_cells: "Очистить данные",
    delete_row: "Удалить строку",
    delete_rows: "Удалить строки",
    detach_gtd_units_confirm: "Вы действительно хотите отвязать грузы?",
    detach_gtd_units_confirm_ok_text: "Отвязать грузы",
    no_units_detach_gtd_error: "Нет грузов, привязанных к декларации",
    detach_order_gtd_form_btn_text: "Отвязать заказ",
    do_not_show_tooltip: "Больше не показывать",
    download: "Скачать",
    drag_here: "Перетащить сюда или <span>выбрать</span>",
    dt_create_field_title: "Дата создания строки",
    edit_rate_expenses: "Изменить котировку",
    edit_row: "Редактировать",
    edit_user_modal_title: "Пользователь",
    email_was_send: "Письмо отправлено ",
    enter_curs_prompt_text_invoice_form: "Введите курс",
    enter_summ_prompt_text_invoice_form: "Введите сумму",
    enter_text_tooltip: "Введите текст",
    error_file_download: "Не удалось загрузить файл",
    bg_export_excel_complete: "Выгрузка файла {= filename} завершена",
    error_big_excel_download: "Превышено максимально допустимое количество строк для выгрузки (10 000).",
    export_prepare_declaration_title: "Выгрузка подготовки декларации",
    exclude_credit_note_from_payments_sum: "Вывести переплату?",
    filters_text: "Добавить фильтр",
    fin_buy: "Покупка",
    fin_clone: "Копировать",
    fin_details_percent_must_be_less_or_equal_then_100: "Сумма процентов не должна превышать 100",
    fin_operation_buy_title: "Фин. операция покупка {- composite_name }",
    fin_operation_sale_title: "Фин. операция продажа {- composite_name }",
    batch_fin_operation_buy_title: "Пакетная фин. операция покупка {- composite_name }",
    batch_fin_operation_sale_title: "Пакетная фин. операция продажа {- composite_name }",
    fin_operationy_disable: "Фин. операции покупки(и/или)продажи уже занесены. Запрещена массовая вставка значений",
    fin_operationy_disable_pay: "Стоит галка \"Покупки занесены\", редактирование и добавление запрещено.",
    fin_operationy_disable_sale: "Стоит галка \"Продажи занесены\", редактирование и добавление запрещено.",
    fin_operationy_disable_invoice: "Нельзя удалить фин. операцию, по которой выставлены счета",
    fin_renominate: "Перевыставить",
    fin_sale: "Продажа",
    fin_sale_by_log_oper: "Продажа лог схемы",
    find_rate_expenses: "Найти котировки",
    form_required_field_error: "Необходимо заполнить элемент",
    full_remove: "Удалить безвозвратно",
    full_remove_row_confirm: "Вы уверены, что хотите безвозвратно удалить эту строку?",
    full_remove_rows_confirm: "Вы уверены, что хотите безвозвратно удалить эти строки?",
    fullscreen_map: "Развернуть карту",
    get_reason_cancel_user_task: "Укажите причину отклонения в комментарии",
    total_gross_weight_title: "Вес брутто",
    gtd_load_error_event_notify_template:
        "Не удалось загрузить декларацию номер {= row.GTD_NUMBER}, причина: {= row.DESCRIPTION}",
    gtd_order_already_exists: "Вы уверены, что хотите заменить существующий заказ №{= order_sys_number}?",
    gtd_success_loaded_event_notify_template:
        "Декларация номер {= row.GTD_NUMBER}, успешно загружена новая запись #{= row.ID_GTD}",
    gtd_success_updated_event_notify_template:
        "Декларация номер {= row.GTD_NUMBER}, успешно обновлена запись #{= row.ID_GTD}",
    hide_column: "Скрыть столбец",
    hour_short_name: "ч",
    import_invalid_file: "Для импорта доступны только файлы с расширением: ",
    import_loading_files: "Загрузка файлов",
    import_loading_files_complete: "Загрузка завершена",
    import_prepare_declaration_title: "Загрузка подготовки декларации",
    importance_1: "Низкая",
    importance_2: "Обычная",
    importance_3: "Срочная",
    industrial_assembly_code: "Коды ТНВЭД (Пром. сборка)",
    initial_tooltip_mathes_text: "Похожих записей: 0",
    inn: "ИНН",
    invalid_name: "Имя не должно быть пустым",
    invoice_confirm_transform_to_simple_money_3: "Вы уверены, что хотите сформировать Доход ДС?",
    invoice_confirm_transform_to_simple_money_4: "Вы уверены, что хотите сформировать Расход ДС?",
    invoice_form_add_rate_expense_type: "Добавить услугу",
    invoice_form_add_simple_position: "Добавить позицию",
    invoice_form_add_units: "Добавить грузовые единицы",
    invoice_form_choose_payment: "Выбрать ПП",
    invoice_form_choose_cash: "Выбрать наличные ДС",
    invoice_form_choose_swift: "Выбрать SWIFT",
    invoice_form_company_title: "Контрагент",
    invoice_form_copy_row: "Копировать",
    invoice_form_create_payment: "Создать ПП",
    invoice_form_create_cash: "Создать наличные ДС",
    invoice_form_create_swift: "Создать SWIFT",
    invoice_form_payer_title: "Плательщик",
    invoice_form_remains: "Остаток:",
    invoice_form_totals: "Итого:",
    invoice_type_2: "Исходящий счет",
    invoice_type_3: "Приход ДС",
    remains: "Остаток",
    invoice_type_1: "Входящий счет",
    invoice_type_4: "Расход ДС",
    invoicing: "Выставление счёта",
    totals: "Итого:",
    is_archive_order_or_crm_error: "Нельзя редактировать запись в архиве",
    is_invoice_date_error: "Нельзя редактировать счет с текущей датой акта",
    is_archive_order: "нельзя редактировать счёт заказа, находящегося в архиве",
    late_invoices_credit_modal_title: "Кредиторская задолженность",
    late_invoices_debit_modal_title: "Дебиторская задолженность",
    late_invoices_unknown_company: "(Не указано)",
    late_invoices_unknown_currency: "(Не указано)",
    linked_company_doc_number_masks_to_company: "Шаблоны номеров счетов:",
    linked_contracts_fea_to_company: "Контракты ВЭД:",
    linked_contracts_to_company: "Договоры:",
    linked_crms_to_company: "Запросы:",
    linked_dog_schemes_to_company: "Шаблоны документальных схем:",
    linked_log_schemes_to_company: "Шаблоны логистических схем:",
    linked_objects_to_company: "Объекты, в которых будет произведена замена контрагента:",
    linked_objects_to_point: "Объекты, в которых будет произведена замена маршуртной точки:",
    linked_orders_to_company: "Заказы:",
    linked_payment_orders_to_company: "Полученные/Отправленные ПП и SWIFT:",
    linked_request_currency_translations_to_company: "Валютные переводы:",
    linked_sea_rates_to_company: "Морские котировки:",
    linked_units_to_company: "Грузы:",
    ldm_total_title: "LDM",
    lng_add: "Добавить",
    lng_clear: "Очистить",
    local_rating_title_driver_form: "Последние",
    log_operationy_disable_or_deleted:
        "Стоит галка \"Покупки занесены\" (и/или) \"Продажи занесены\", редактирование и добавление запрещено.",
    log_operationy_disable: "Стоит галка \"Покупки занесены\" (и/или) \"Продажи занесены\", вставка значений запрещена.",
    matches_count: "Количество похожих записей: ",
    max_100_add_transfer_units: "Нельзя добавить более 100 единиц за раз",
    menu_edit_title: "Настройка меню",
    menu_item_edit_title: "Настройка пункта меню",
    message_box_placeholder: "Введите сообщение",
    min_all_apps: "Свернуть все",
    min_width_all_columns: "Стянуть все столбцы",
    link_invoice: "Привязать счет",
    min_width_column: "Стянуть столбец",
    minute_short_name: "м",
    modal_title_new_row: "Новая строка",
    model_rating_title_driver_form: "Рейтинг перевозки",
    month_start: "Начало месяца",
    multi_add_transfer_unit_button_title: "Добавить несколько единиц",
    multi_currency_payments:
        "Мультивалютные платежи<br>После выбора платежа в валюте, отличающейся от валюты счета,<br>необходимо задать курс конверсии на день оплаты",
    must_selected_packing_positions: "Необходимо выделить строки в двух таблицах для перетарки",
    need_save_form: "Необходимо сохранить форму",
    need_select_company_in_crm_form: "Нужно выбрать контрагента",
    total_netto_weight_title: "Вес нетто",
    new_chat_message: "Новое сообщение",
    new_chat_message_noty_title: "Новое сообщение в чате",
    new_task_noty_title: "Новая задача",
    no_chat_contacts: "Нет пользователей",
    no_chat_dialogs: "Нет активных диалогов",
    no_chat_messages: "Нет сообщений",
    no_chat_rooms: "Нет групп",
    no_comments: "Комментариев нет",
    no_dialogs_search_messages: "Сообщения не найдены",
    no_filters_text: "Нет фильтров",
    no_photo_text: "Загрузите фотографию",
    no_route_ata_date_driver_form: "Дата не указана",
    not_found: "Ничего не найдено",
    not_found_fields: "Ничего не найдено",
    notification_template_accept_task_with_comment: "{=comment.message}",
    notification_template_task_comment: "{=comment.message}",
    ok: "OK",
    ok_clear_scheme_in_order: "Очистить схему",
    operation_air: "Авиационная",
    operation_auto: "Автомобильная",
    operation_by_object_title: "Финансовые операции объекта \"{= query}\" #{= id}",
    operation_customs: "Таможенная",
    operation_must_have_account_currency: "Валюта этой операции не соответствует валюте ее счета: ",
    operation_not_allowed: "Недостаточно прав для выполнения операции",
    operation_request_scheme_task__parallel: "Параллельная",
    operation_request_scheme_task__prev: "Предыдущая",
    operation_request_scheme_task__series: "Последующая",
    operation_sea: "Морская",
    operation_train: "Железнодорожная",
    operation_type_name_auto: "Автомобильная",
    operation_unit_from_part_number_create: "Создать",
    operation_unit_from_part_number_select: "Выбрать",
    operations_summ_must_be_equal_zero: "Сумма операций должна быть равна нулю",
    operations_task_sea_like_auto: "Морская (отдельно)",
    order_docs_email_error: "Ошибка при отправке писем",
    order_docs_email_success: "Письма будут отправлены в ближайшее время",
    order_docs_email_wait_previous_sending: "Дождитесь завершения предыдущей рассылки",
    order_has_no_units_related_to_declaration:
        "Не удалось сопоставить номера грузовых единиц заказа и декларации, вы уверены что хотите привязать ДТ к этому заказу?",
    order_position_quantity_over_max: "Максимально возможное значение: {= max - otherPositionsSum}",
    order_position_quantity_over_min: "Минимальное возможное значение: {= min}",
    order_profit_by_oper_type_by_year__fin_sum_buy: "Покупка",
    order_profit_by_oper_type_by_year__fin_sum_diff: "Прибыль",
    order_profit_by_oper_type_by_year__fin_sum_sale: "Продажа",
    order_profit_by_oper_type_by_year__inv_sum_buy: "Покупка",
    order_profit_by_oper_type_by_year__inv_sum_diff: "Прибыль",
    order_profit_by_oper_type_by_year__inv_sum_sale: "Продажа",
    order_profit_by_oper_type_by_year__no_oper_type: "(Без типа)",
    order_profit_by_oper_type_by_year__total: "Итого",
    order_profit_by_oper_type_by_year_value_group__fact: "Факт",
    order_profit_by_oper_type_by_year_value_group__plan: "План",
    order_type_AIR: "Авиа",
    order_type_FCL: "FCL",
    order_type_FTL: "FTL",
    order_type_LAL: "LAL",
    order_type_LCL: "LCL",
    order_type_LCL_export: "LCL экспорт",
    order_type_LCL_import: "LCL импорт",
    order_type_LRL: "LRL",
    order_type_LTL: "LTL",
    order_type_TRAIN: "ЖД",
    order_units_by_year__fin_sum: "Маржинальность план",
    order_units_by_year__inv_sum: "Маржинальность факт",
    order_units_by_year__orders_count: "Кол-во заказов",
    order_units_by_year__total_in_row: "Общий итог",
    order_units_by_year__total_row_name: "Общий итог",
    order_units_by_year__units_count: "Кол-во грузов",
    order_units_by_year_direction__1: "Импорт",
    order_units_by_year_direction__2: "Экспорт",
    order_units_by_year_direction__3: "РФ",
    order_units_by_year_direction__4: "Транзит",
    order_units_by_year_direction__unknown: "(Без направления)",
    order_units_by_year_unit_type_plan_name: "Тип грузовой единицы",
    order_units_by_year__list_delivery_conditions_name: "Условия поставки",
    order_units_by_year_teu: "TEU",
    order_units_by_year_unknown_order_type: "(Без типа)",
    order_units_create_menu_choose: "Выбрать",
    order_units_create_menu_choose_owner_unit_empty: "Выбрать порожний",
    order_units_create_menu_choose_owner_unit_freight: "Выбрать груженый",
    order_units_create_menu_create: "Создать",
    order_units_create_menu_create_batch: "Пакетное создание",
    order_without_client: "Невозможно создать заказ. Необходимо сменить статус для потенциального клиента.",
    owner_unit_point_address: "Адрес",
    pass1_less_then_6: "Этот пароль содержит меньше 6 символов",
    pass1_not_equal_pass2: "Введенные пароли не совподают",
    password_tooltip: "Пароль должен содержать не меньше 6 символов",
    paste: "Вставить",
    paste_row_not_found: "Строка для вставки не найдена",
    paste_type_error: "Типы данных не совподает, <br/>невозможно выполнить вставку",
    payment_order_form_remains: "Остаток:",
    payment_order_form_totals: "Итого:",
    placeholder_enter_text: "Введите текст",
    please_enable_cam: "Пожалуйста, включите камеру",
    please_select_operation: "Пожалуйста, выберите операцию",
    please_select_operation_type: "Пожалуйста, выберите тип операции",
    plugin_only_from_form: "Плагин расчитан тольк на формы",
    print_btn_text: "Печать",
    quantity_total_title: "Количество мест",
    rate_expenses_default_rur: "RUB",
    read_notification_read_all: "Прочитать все",
    delete_group_chat: "Удалить группу",
    read_notification_read_selection: "Прочитать выделенное",
    receive_new_task_notifications: "Новые задачи",
    receive_task_action_notifications: "Действия к задачам",
    receive_task_comment_notifications: "Комментарии к задачам",
    receive_unload_in_port_notifications: "Выгрузка в порту",
    user_profile_notify_settings: "Настройка уведомлений",
    received_payment_order: "Полученное ПП",
    reminder_picker_checkbox_line_text_duration_10: "10 минут",
    reminder_picker_checkbox_line_text_duration_10080: "неделю",
    reminder_picker_checkbox_line_text_duration_1440: "день",
    reminder_picker_checkbox_line_text_duration_30: "30 минут",
    reminder_picker_checkbox_line_text_duration_60: "час",
    remove_desktop_icon: "Удалить",
    remove_desktop_icon_confirm_text: "Вы уверены, что хотите удалить?",
    remove_invoice_btn_text_invoice_form: "Удалить документ",
    remove_invoice_confirm_text_invoice_form: "Вы действительно хотите удалить документ?",
    remove_invoice_position_renominate_warning:
        "У данной позиции есть перевыставленная в счете #{=RENOMINATION_INVOICE_TO}.<br> Вы уверены, что хотите удалить эту строку?",
    remove_invoice_renominate_warning:
        "У данного документа есть перевыставленные: {=RENOMINATION_LINK}. Вы уверены, что хотите удалить документ?",
    remove_position_invoice_form: "Удалить строку",
    remove_row_confirm: "Вы уверены, что хотите удалить эту строку?",
    remove_rows_confirm: "Вы уверены, что хотите удалить эти строки?",
    remove_selected_confirm: "Вы уверены, что хотите удалить эти данные?",
    remove_tab_confirm_text_invoice_form: "Вы уверены, что хотите удалить вкладку с ее позициями?",
    remove_tab_invoice_form: "Удалить услугу",
    remove_transfer_button_text__transfer_unit_form: "Удалить плечо",
    remove_transfer_confirm_text__transfer_unit_form: "Вы действительно хотите удалить это плечо?",
    remove_transfer_link_button_text__transfer_unit_form: "Отвязать плечо",
    remove_transfer_link_confirm_text__transfer_unit_form: "Вы действительно хотите отвязать это плечо?",
    rename_desktop_icon: "Переименовать",
    renomination_all_invoice: "Весь счет",
    renomination_check_need_outgoing_yesno: "Перевыставить только отмеченные?",
    renomination_checked_positions: "Отмеченные позиции",
    renomination_invoice_btn_text_invoice_form: "Перевыставить",
    renomination_invoices: "Перевыставить счета",
    repackgin_form_modal_title: "Перетарка грузовых единиц",
    reports_updated: "Отчеты обновлены",
    cannot_update_reports: "Невозможно обновить отчеты",
    request_auto_comment_on_update: "Внесены изменения",
    required_invoice_mask: "Необходимо заполнить маску",
    req_create: "Создать",
    req_clone: "Копировать",
    clone: "Копировать",
    restore: "Восстановить",
    row_locked_by_other_user: "В настоящий момент данная запись редактируется пользователем",
    row_was_deleted_text: "Строка была удалена",
    row_was_restored_text: "Строка была восстановлена",
    safe_column_error: "Столбец \"{=column}\" редактировать запрещено",
    safe_row_edit_error: "Столбец \"{=column}\" редактировать запрещено. {=reason}",
    save_before_close: "Сохранить изменения?",
    save_button: "Сохранить",
    scheme_add_point: "Добавить точку",
    select: "Выбрать",
    select_all: "Выбрать все",
    select_rate_expenses: "Выбрать действующую",
    selected_packing_positions_must_be_valid: "Вес нетто, Вес брутто и Количество должны быть больше нуля",
    selected_units_are_from_different_orders: "Можно выбрать грузы только одного заказа",
    selection_total_quantity: "Количество",
    selection_total_sum: "Сумма",
    send_data_by_email: "Отправить по почте",
    sent_payment_order: "Отправленное ПП",
    server_error_delete_rows: "Во время удаления на сервере произошла ошибка. <br/>Попробуйте повторить запрос позднее",
    set_curs_invoice_form: "Курс",
    set_summ_invoice_form: "Сумма",
    shipment_export_cargo_print_addition_btn_text: "Приложение",
    shipment_export_cargo_print_btn_text: "Печать",
    show_last_selected_point_on_map: "Перейти к последней выбранной точке",
    sometype: "Тип",
    sort_mode_context_item_title_off: "Сортировка выкл.",
    sort_mode_context_item_title_on: "Сортировка вкл.",
    success_calc_order_gtd_tax: "Пошлина: {= GTD_TAX}, НДС: {= GTD_PREPAYMENT}",
    success_calc_order_gtd_tax_title: "Новые значения",
    success_change_password: "Новый пароль сохранен",
    success_send_auto_messages: "Сообщения отправлены",
    sum_payment_actual_limit: "Сумма оплаты превышает доступную сумму платежа",
    sum_payment_maximum_limit: "Сумма оплаты превышает сумму платежа",
    sum_payment_zero_limit: "Сумма оплаты не должна быть отрицательной",
    sys_notifications_startup_two_description: "Количество непрочитанных уведомлений: {=count}",
    sys_notifications_unreaded_startup_two_title: "Новые уведомления",
    system_delegate_user_task_notification_template:
        "Тип: {= escapeHtml(NOTIFICATIONS_TYPE_NAME)}<br/>Пользователь: {= escapeHtml( LIST_USER_NAME_CREATE )}<br/>{= (NEW_USER_EXECUTOR_FULL_NAME ? ('Новый исполнитель: ' + NEW_USER_EXECUTOR_FULL_NAME) : '')}<br/>{= (ROW_OBJECT ? ('Объект: ' + escapeHtml(ROW_OBJECT)) : '')}<br/>{= (MESSAGE ? ('Сообщение: ' + escapeHtml(MESSAGE)) : '')}",
    system_notification_template:
        "Тип: {= escapeHtml(NOTIFICATIONS_TYPE_NAME)}<br/>Пользователь: {= escapeHtml( LIST_USER_NAME_CREATE )}<br/>{= (ROW_OBJECT ? 'Объект: ' + escapeHtml(ROW_OBJECT) : '')}<br/>{= (MESSAGE ? 'Сообщение: ' + escapeHtml(MESSAGE) : '')}",
    system_notification_title: "Уведомление",
    table_no_rows: "Нет записей",
    table_tab_confirm_remove_text: "Удалить вкладку: ",
    table_tab_confirm_title: "Удаление вкладки",
    tabs_all_title: "Все",
    tabs_delivered_title: "Доставлен",
    tabs_inProgress_title: "В работе",
    task_accept_action_text: "Принять",
    task_accept_with_comment_action_text: "Принять с комментарием",
    task_actions_button_text: "Действие",
    task_delegate_action_text: "Делегировать",
    task_finish_action_text: "Завершить",
    task_pause_action_text: "Приостановить",
    task_reject_action_text: "Отклонить",
    task_resume_action_text: "Возобновить",
    tasks_unreaded_startup_two_description: "Количество непрочитанных задач: {=count}",
    tasks_unreaded_startup_two_title: "Новые задачи",
    thank: "Спасибо",
    time_type: "Дни/Часы",
    time_type_days: "Дни",
    time_type_hours: "Часы",
    timelength_d: "д",
    timelength_h: "ч",
    timelength_m: "м",
    today: "Сегодня",
    toolbar_account_remains: "Остаток",
    total: "Итого",
    total_rating_title_driver_form: "Общий рейтинг",
    total_row_text: "Итого:",
    total_text_transfer_unit_form:
        "Прибыль: {=currencySpaces(round2(rub, 2))} (RUB) или {=currencySpaces(round2(usd, 2))} (USD) или {=currencySpaces(round2(eur, 2))} (EUR)",
    transfer_all_company_group_name: "Контрагенты",
    transfer_request_attach_user_notification_template: "Вас добавили в запрос #{= row.ID_GTD}: {= row.NAME}",
    transfer_request_default_name_prefix: "Запрос",
    transfer_unit_form__type_menu__air: "Авиационное",
    transfer_unit_form__type_menu__auto: "Автомобильное",
    transfer_unit_form__type_menu__customs: "Таможенное оформление",
    transfer_unit_form__type_menu__forward: "Экспедирование",
    transfer_unit_form__type_menu__sea: "Морское",
    transfer_unit_form__type_menu__train: "Железнодорожное",
    trash: "Корзина",
    trash_show: "Показать корзину",
    uimodal_toggle_details: "Подробнее",
    uniq_error_invoice_doc_date_company: "Существует счет #{=ID} с таким же номером, датой и контрагентами",
    unit_in_move: "В пути",
    unit_in_point: "На станции",
    unit_switch_off_tracking_btn_text: "Снять со слежения",
    unit_switch_on_tracking_btn_text: "Поставить на слежение",
    unit_without_expected_date: "(Без даты)",
    unit_without_type: "(Без типа)",
    unknown: "Неизвестная ошибка",
    unknown_option_title: "Заголовок неизвестен",
    unpacking_grid_must_have_selection_for_return: "Необходимо выделить строку в развале справа",
    unselect_all: "Снять все",
    upload_files: "Загрузить файлы",
    user_added_task: "поставил(а)",
    user_added_task_: "задачу",
    user_create_field_title: "Владелец записи",
    user_profile_email: "E-mail",
    user_profile_email_placeholder: "Введите e-mail",
    user_profile_password: "Пароль",
    user_profile_password_repeat: "Повторите пароль",
    user_profile_password_success_change_text: "Ваш пароль успешно изменен",
    user_profile_password_success_change_title: "Изменение пароля",
    user_profile_phone: "Телефон",
    user_profile_phone2: "Телефон 2",
    user_profile_phone_placeholder: "Введите номер телефона",
    user_profile_save_pass: "Сохранить пароль",
    user_role_modal__roles_title: "Роли",
    user_role_modal__users_title: "Пользователи",
    user_task_create_by_template: "По шаблону",
    user_task_dates: "Срок",
    user_task_description: "Описание",
    user_task_reference: "Объект",
    user_task_simple_create: "Новая",
    user_task_theme: "Тема",
    user_task_was_delegated_to: "Задача делегирована пользователю: {= new_user_full_name}",
    users: "Пользователи",
    users_table_select_count_text: "Выбрано пользователей",
    usual_code: "Коды ТНВЭД",
    vat: "VAT",
    volume_total_title: "Объем",
    walpers_modal_title: "Обои рабочего стола",
    wallpapers_modal_title: "Обои рабочего стола",
    weak_required_elem: "Необходимо заполнить элемент",
    week_start: "Начало недели",
    weight_groups_mismatch: "Группа товаров наименования не совпадает с группой товаров контракта",
    word_to_search: "Фраза для поиска",
    year_start: "Начало года",
    client_payment_balance__unknown_currency: "(Не указано)",
    client_payment_balance__begin_balance_name: "Начальное сальдо",
    auto_created_and_mirror_payment_error: "Запрещено редактировать автоматически созданные или зеркальные платежные поручения",
    mirror_payment_error: "Запрещено редактировать зеркальные платежные поручения",
    fin_operation_editing_disabled_cause_has_invoice:
        "Редактирование запрещено. По данной фин. операции выставлен счет.",
    confirm_before_paste: "Вы действительно хотите вставить данные в таблицу?",
    grid_list_help: "Помощь",
    grid_list_any_role: "Подходит любая роль",
    grid_list_help_alert_title: "Подходящие роли",
    grid_list_roles: "Роли",
    supplier_company: "Поставщик",
    broker_company: "Таможенный брокер",
    get_docs_from_supplier: "Получение документов от поставщика",
    manufacturer: "Производитель",
    operation_base_elements__docs: "Документы",
    operation_base_elements__route: "Маршрут",
    operation_base_elements__operations: "Операции",
    change_currency_of_invoice_with_payment_order_error: "Нельзя изменять валюту счёта, связанного с ПП",
    unique_LIST_COMPANY_inn: "ИНН занят",
    no_order_id: "Нельзя создать грузовые единицы без ID заказа",
    invoice_all_positions_insert_clipboard_error: "Необходимо добавить услугу",
    dont_touch_system_transfer: "Нельзя изменить или удалить системную проводку",
    partner: "Партнёр",
    consignee: "Грузополучатель",
    contract_number: "Номер контракта",
    reference: "Референс",
    unit_record_number: "Номер записи груза",
    unit_number: "Номер грузовой единицы",
    group_number: "№ сборника",
    quantity: "Количество мест",
    net_weight: "Вес нетто",
    gross_weight: "Вес брутто",
    packaging_type: "Тип упаковки",
    quantity_pallet: "Количество паллет",
    order_type_name: "Тип заказа",
    dt_terminal_name: "Терминал подачи",
    point_cbx_name: "Терминал прибытия",
    min_date_gtd_clear_expected: "Расчётная дата ТО",
    contract_type: "Вид контракта",
    declaration_kind: "Тип ДТ",
    crm_name: "Наименование запроса",
    delivery_conditions: "Условия поставки",
    quantity_expected: "Количество, план",
    unit_type_expected: "Тип грузовых единиц, план",
    arrival_point_first: "Первая точка маршрута",
    arrival_point_last: "Последняя точка маршрута",
    ship_arrival_date_plan_for_loading: "Планируемая дата прибытия судна под загрузку",
    list_name_weight_name: "Наименование груза",
    point_port_start_name: "Порт отправления",
    point_start_name: "Место забора груза",
    booking_number: "Номера букингов",
    point_end_name: "Место доставки груза",
    unit_division_name: "Тип груза",
    vessel_name: "Наименование фидерного судна",
    operations_names: "Схема",
    name_error: "Совпадение по наименованию",
    website_error: "Совпадение по сайту",
    phone_error: "Совпадение по телефону",
    company_trashed_error: "Контрагент находится в корзине",
    collision_error: "Указанные поля совпадают с уже существующей записью",
    required_field_error: "Необходимо заполнить элемент",
    company_already_exists: "Компания уже существует:",
    Container: "Контейнер",
    old_log_scheme_operations_have_invoices: "По фин. операциям старой лог. схемы выставлены счета.",
    unable_to_select_log_scheme:
        "Нельзя выбрать новую лог. схему т.к. стоит галка \"Покупки занесены\" (и/или) \"Продажи занесены\".",
    unable_clear_rates_invoices_exists: "Нельзя очистить ставки, т.к. выставлены счета.",
    unable_clear_rates_sales_or_buys_are_recorded_:
        "Нельзя очистить ставки, т.к. стоит галка \"Покупки занесены\" (и/или) \"Продажи занесены\".",
    dont_remove_invoice: "Нельзя удалить инвойс, по которому выставлены счета",
    create_transfer__note: "Примечание",
    create_driver: "Создать",
    choose_driver: "Выбрать",
    create_auto: "Создать",
    choose_auto: "Выбрать",
    Tk: "таможенная карта",
    capital_account_balance_total: "Итого:",
    head_of_the_farm: "Глава крестьянского (фермерского) хозяйства",
    IP: "ИП",
    invoices_is_not_create: "Декларация не соответствует условиям для выставления расходов по шаблону",
    cost_of_the_pattern: "Выставить расходы по шаблону?",
    yesterday: "Вчера",
    week_day_sn: "Вс",
    week_day_m: "Пн",
    week_day_t: "Вт",
    week_day_w: "Ср",
    week_day_th: "Чт",
    week_day_f: "Пт",
    week_day_s: "Сб",
    no_edit_unit_in_renomination_invoice: "В перевыставленном счете грузовую единицу редактировать нельзя",
    Remove: "Удалить",
    Unlink: "Отвязать",
    remove_or_unlink: "Вы уверены, что хотите удалить/отвязать эту строку?",
    choose_action: "Выберите действие",
    has_forward_operation: "Экспедирование",
    x5__supply_orders: "Заказы",
    x5__orders_all: "Поставки (все)",
    x5__orders_archive: "Поставки (архив)",
    x5__orders_current: "Поставки (текущие)",
    dont_touch_not_new_supply_order: "Нельзя изменить или удалить подтвержденный заказ",
    use_plugin_only_for_forms: "Плагин рассчитан только на формы",
    get_reason_reject_supply_order: "Укажите причину в комментариях",
    get_reason_recall_supply_order: "Укажите причину в комментариях",
    cannot_recall_working_supply_order: "Нельзя отозвать заказ с поставками",
    cannot_reject_working_supply_order: "Нельзя отклонить заказ с поставками",
    no_save_sea_rates_duplicates:
        "Некоторые котировки с теми же параметрами были сохранены ранее. Они не будут сохранены повторно.",
    single_start_point_if_more_than_one_end_point:
        "Нельзя выбрать более одного места отправления, если выбрано более одного места назначения",
    single_end_point_if_more_than_one_start_point:
        "Нельзя выбрать более одного места назначения, если выбрано более одного места отправления",
    create_single_sea_rate: "Добавить котировку",
    create_multiple_sea_rate: "Пакетное добавление котировок",
    every_supply_order_should_have_same_status: "Все заказы должны иметь одинаковый статус",
    choose_all_time_find_analogue: "За всё время",
    choose_3_month_find_analogue: "За три месяца",
    els: "елс",
    tk: "таможенная карта",
    every_supply_order_should_have_filled:
        "В заказе {= order_number } необходимо заполнить обязательные поля: <br/>{= required_fields}",
    every_supply_order_should_have_valid_positions_count:
        "В заказе {= order_number } количество контейнеров/ТС должно быть равно количеству позиций",
    every_supply_order_should_have_valid_positions_plu:
        "В заказе {= order_number } все позиции должны иметь одинаковую продукцию",
    every_supply_order_should_have_positions: "В заказе {= order_number } необходимо заполнить позиции",
    every_supply_order_should_have_position_filled:
        "В заказе {= order_number } необходимо заполнить поля позиции: <br/>{= required_fields}",
    kg: "кг",
    confirm_kick_another_user: "Эта учетная запись уже используется.<br/>Продолжить вход?",
    user_another_login: "Отмена",
    continue_kick: "Войти",
    somebody_try_login: "Другой пользователь пытается войти под вашей учетной записью",
    somebody_kick_you: "Другой пользователь зашёл под вашей учетной записью",
    login: "Войти",
    no_unique_list_company_name: "Нельзя восстановить, т.к. есть контрагент с таким же именем",
    pre_detach_all_attached_units: "К данной таможенной декларации привязаны грузы. Отвязать их или оставить?",
    save_attached_units_and_orders: "Оставить",
    detach_attached_units_and_orders: "Отвязать",
    choose_from_attached_orders_ask:
        "Для новой грузовой единицы выбрать заказ из прикреплённых к Таможенной декларации?",
    choose_from_attached_orders: "Из прикреплённых",
    choose_from_all_orders: "Из всех",
    choose_from_attached_order_ask: "Для новой грузовой единицы выбрать заказ, прикреплённый к Таможенной декларации?",
    choose_from_attached_order: "Выбрать прикреплённый заказ",
    choose_from_all_orders2: "Выбрать из всех заказов",
    create_new_order_ask: "Для новой грузовой единицы создать новый заказ?",
    create_new_order: "Создать новый заказ",
    choose_from_all_orders3: "Выбрать из имеющихся",
    date_rates_ends_expired:
        "Для некоторых выбранных операций<br> истёк срок действия ставок.<br> Обновить даты этих ставок?",
    clear_expired_date_rates_ends_and_init_date_rates_starts_by_now: "Обновить даты",
    keep_existing_dates_rates_starts: "Не обновлять",
    customs_nomenclature_type_name: "Таможенные платежи",
    rights_name__toolbar: "Панель инструментов",
    rights_name__columns: "Столбцы",
    rights_name__filters: "Фильтры",
    rights_name__own_rows: "Cвои записи",
    rights_name__department_rows: "Записи отдела",
    rights_name__roles: "Роли",
    rights_name__other: "Остальные",
    rights_name__form: "Форма",
    rights_name__form_reports: "Бланки",
    rights_name__form_generate_reports: "Сформировать бланки",
    rights_name__form_buttons: "Кнопки",
    rights_name__grid_head: "Шапка",
    rights_name__create_log_oper: "Создание операции",
    rights_name__comments: "Комментарии",
    rights_name__empty_exclusive: "(Пустой)",
    rights_name__log_oper_route: "Маршрут",
    cant_remove_part_number_with_archive_unit: "Нельзя удалять инвойсы, которые привязаны к архивным грузам",
    notChooseBlockInvoice: "Необходимо выбрать хотя бы один блок для переноса",
    form_elements_need_defined_size: "Элементам формы нужно знать размер, в котором открывается форма",
    no_model_no_form: "Нет модели - нет формы",
    paramsby_need_eid: "для paramsBy необходим eid",
    eid_reserved: "Нельзя использовать такой eid (зарезервированно системой)",
    eid_must_be_ubique: "Свойство eid должно быть уникальным, найден повтор",
    prepayment_report__name: "Наименование",
    prepayment_report__date: "Дата",
    prepayment_report__company: "Компания",
    prepayment_report__debet: "Дебет",
    prepayment_report__credit: "Кредит",
    prepayment_report__note: "Примечание",
    prepayment_report__some_vat: "НДС {= vat_value }",
    prepayment_report__vat__without_vat: "Без НДС",
    prepayment_report__vat__unknown_vat: "НДС не указан",
    prepayment_report__begin_balance_name: "Начальное сальдо",
    date_not_provided: "(дата не указана)",
    from: "от",
    notChooseAnalogue: "Необходимо выбрать строку для переноса.",
    invalid_unit_number: "Поле \"Грузовая единица\" должно содержать только латиницу",
    invalid_auto_unit_number:
        "Поле \"Грузовая единица\" должно содержать только латиницу или быть вида */*, где * - символы латиницы и цифры от 1 до n",
    invalid_air_unit_number:
        "Поле \"Грузовая единица\" должно содержать только латиницу или быть вида *-*, где * - символы латиницы и цифры от 1 до n",
    logoper_train_sub_doc_app: "ЖД накладные",
    must_first_apply_the_changes: "Прежде необходимо применить внесённые изменения",
    chat_clear_history: "Очистить историю",
    chat_unmute: "Включить уведомления",
    chat_mute: "Отключить уведомления",
    chat_read_all: "Прочитать все",
    chat_set_as_read: "Отметить прочитанным",
    chat_set_as_unread: "Отметить не прочитанным",
    chat_open_link: "Открыть",
    chat_download_link: "Скачать",
    chat_remove_message: "Удалить",
    chat_remove_message_for_all_users: "Удалить для всех",
    chat_clipboard_copy: "Копировать",
    reason_for_working_with_company: "С данным контрагентом работа возобновлена по следующим причинам:",
    reason_for_stop_working_with_company: "С данным контрагентом работа прекращается по следующим причинам:",
    help_for_doc_number_generator:
        "\n                <div>Текущее значение:</div>\n                <div class='current-value' style='height:17px'>&nbsp;</div>\n                <br/>\n                \n                <div>Пример маски:</div>\n                <div>MSK-<b>{dd}</b>/<b>{mm}</b>/<b>{yyyy}</b> <b>{vacant of month, start 5000}</b></div>\n                <div>MSK-09/10/2017 5019</div>\n                <br/>\n\n                <div>Виды масок:</div>\n                <br/>\n\n                <div>Контрагент:</div>\n                <div><b>{company_name}</b> наименование контрагента</div>\n                <br/>\n\n                <div>Даты:</div>\n                <div><b>{dd}</b> день, 01 или 31</div>\n                <div><b>{mm}</b> месяц, 01 или 12</div>\n                <div><b>{yy}</b> год, 98 или 18</div>\n                <div><b>{yyyy}</b> год, 2018</div>\n                <br/>\n\n                <div>Номер записи за все время</div>\n                <div><b>{id}</b></div>\n                <br/>\n\n                <div>Номер записи в рамках интервала</div>\n                <div><b>{# of day}</b> номер в рамках дня</div>\n                <div><b>{# of month}</b> номер в рамках месяца</div>\n                <div><b>{# of year}</b> номер в рамках года</div>\n                <div><b>{# of day, start 1000}</b> номер в рамках дня плюс 1000</div>\n                <div><b>{# of month, start 1000}</b> номер в рамках месяца плюс 1000</div>\n                <div><b>{# of year, start 1000}</b> номер в рамках года плюс 1000</div>\n                <div><b>{# of year, zero 000}</b> номер в рамках года с ведущими нулями, пример номера: 001</div>\n                <div><b>{# of year, zero 0000, start 50}</b> номер в рамках года, плюс 50 и с ведущими нулями, пример номера: 0051</div>\n                <br/>\n\n                <div>Незанятый номер в рамках интервала</div>\n                <div><b>{vacant of day}</b> номер в рамках дня</div>\n                <div><b>{vacant of month}</b> номер в рамках месяца</div>\n                <div><b>{vacant of year}</b> номер в рамках года</div>\n                <div><b>{vacant of day, start 1000}</b> номер в рамках дня плюс 1000</div>\n                <div><b>{vacant of month, start 1000}</b> номер в рамках месяца плюс 1000</div>\n                <div><b>{vacant of year, start 1000}</b> номер в рамках года плюс 1000</div>\n                <div><b>{vacant of year, zero 000}</b> номер в рамках года с ведущими нулями, пример номера: 001</div>\n                <div><b>{vacant of year, zero 0000, start 50}</b> номер в рамках года, плюс 50 и с ведущими нулями, пример номера: 0051</div>\n                <br/>\n                <br/>\n                <br/>\n\n                <div>Валовые номера, идущие друг за другом, Запрещенно использовать без Не числового разделителя.</div>\n                <br/>\n                \n                <div><b>Примеры запрещенных шаблонов:</b></div>\n                <div>MSK-<b>{# of month<u style='color:red'>}{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>1</u>{# of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>12</u>{# of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>999</u>{# of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}{id}{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}{dd}{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}{mm}{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}{yyyy}{</u># of day}</b> </div>\n                <br/>\n\n                <div><b>Пример правильного разделения:</b></div>\n                <div>MSK-<b>{# of month<u style='color:green'>}/{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:green'>}-{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:green'>} {</u># of day}</b> </div>\n                \n                ",
    help_for_doc_number_generator_order:
        "\n                <div>Текущее значение:</div>\n                <div class='current-value' style='height:17px'>&nbsp;</div>\n                <br/>\n                \n                <div>Пример маски:</div>\n                <div>MSK-<b>{dd}</b>/<b>{mm}</b>/<b>{yyyy}</b> <b>{vacant of month, start 5000}</b></div>\n                <div>MSK-09/10/2017 5019</div>\n                <br/>\n\n                <div>Виды масок:</div>\n                <br/>\n\n                <div>Контрагент:</div>\n                <div><b>{company_name}</b> наименование контрагента</div>\n                <div><b>{company_name_small}</b> краткое наименование контрагента</div>\n                <br/>\n\n               <div>Менеджеры:</div>\n                <div><b>{operations_manager_initials}</b> Инициалы оперативного менеджера</div>\n                <br/>\n\n                <div>Даты:</div>\n                <div><b>{dd}</b> день, 01 или 31</div>\n                <div><b>{mm}</b> месяц, 01 или 12</div>\n                <div><b>{yy}</b> год, 98 или 18</div>\n                <div><b>{yyyy}</b> год, 2018</div>\n                <br/>\n\n                <div>Номер записи за все время</div>\n                <div><b>{id}</b></div>\n                <br/>\n\n                <div>Номер записи в рамках интервала</div>\n                <div><b>{# of day}</b> номер в рамках дня</div>\n                <div><b>{# of month}</b> номер в рамках месяца</div>\n                <div><b>{# of year}</b> номер в рамках года</div>\n                <div><b>{# of day, start 1000}</b> номер в рамках дня плюс 1000</div>\n                <div><b>{# of month, start 1000}</b> номер в рамках месяца плюс 1000</div>\n                <div><b>{# of year, start 1000}</b> номер в рамках года плюс 1000</div>\n                <div><b>{# of year, zero 000}</b> номер в рамках года с ведущими нулями, пример номера: 001</div>\n                <div><b>{# of year, zero 0000, start 50}</b> номер в рамках года, плюс 50 и с ведущими нулями, пример номера: 0051</div>\n                <br/>\n\n                <div>Незанятый номер в рамках интервала</div>\n                <div><b>{vacant of day}</b> номер в рамках дня</div>\n                <div><b>{vacant of month}</b> номер в рамках месяца</div>\n                <div><b>{vacant of year}</b> номер в рамках года</div>\n                <div><b>{vacant of day, start 1000}</b> номер в рамках дня плюс 1000</div>\n                <div><b>{vacant of month, start 1000}</b> номер в рамках месяца плюс 1000</div>\n                <div><b>{vacant of year, start 1000}</b> номер в рамках года плюс 1000</div>\n                <div><b>{vacant of year, zero 000}</b> номер в рамках года с ведущими нулями, пример номера: 001</div>\n                <div><b>{vacant of year, zero 0000, start 50}</b> номер в рамках года, плюс 50 и с ведущими нулями, пример номера: 0051</div>\n                <br/>\n                <br/>\n                <br/>\n\n                <div>Валовые номера, идущие друг за другом, Запрещенно использовать без Не числового разделителя.</div>\n                <br/>\n                \n                <div><b>Примеры запрещенных шаблонов:</b></div>\n                <div>MSK-<b>{# of month<u style='color:red'>}{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>1</u>{# of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>12</u>{# of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>999</u>{# of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}{id}{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}{dd}{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}{mm}{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:red'>}{yyyy}{</u># of day}</b> </div>\n                <br/>\n\n                <div><b>Пример правильного разделения:</b></div>\n                <div>MSK-<b>{# of month<u style='color:green'>}/{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:green'>}-{</u># of day}</b> </div>\n                <div>MSK-<b>{# of month<u style='color:green'>} {</u># of day}</b> </div>\n                \n                ",
    help_for_doc_number_generator_train: `
        <h4>Пример маски:</h4>
        <p>
            УЛТК - <b>{vacant of mask}</b></b>
        </p>

        <h4>Допустимые элементы маски:</h4>
        <ul>
            <li>
                <b>{id}</b> - Номер записи в базе данных.
            </li>
            <li>
                <b>{vacant of mask}</b> - Вакантный номер в рамках маски.
            </li>
            <li>
                <b>{vacant of mask, start 10}</b> - Вакантный номер в рамках маски, с указанием минимального значений.
            </li>
        </ul>
    `,
    name_column: "Наименование",
    date_column: "Дата",
    note_column: "Примечание",
    credit_column: "Кредит",
    debit_column: "Дебет",
    our_company_name_column: "Контрагент",
    company_column: "Компания",
    company_client_column: "Клиент",
    company_partner_column: "Партнер",
    crm_source_request_name: "Источник обращения",
    ddt_row_number: "Номер строки",
    ddt_finished_loading: "Загрузка завершена",
    ddt_loaded_with_errors: "Ошибка при загрузке файлов",
    cannot_remove_fin_oper_with_invoices: "Нельзя удалить фин. операцию, по которой выставлены счета",
    invoice_without_doc_number: "№ счета (не определено)",
    ztm_validate_position: "Позиция",
    late_invoices_orders_numbers: "Номера заказов",
    late_invoices_units_numbers: "Грузовые единицы",
    late_invoices_units_ids: "Номера записей грузовых единиц",
    late_invoices_subdivision_names: "Подразделения",
    late_invoices_manager_names: "Менеджеры по продажам",
    late_invoices_op_manager_names: "Оперативные менеджеры",
    late_invoices_invoice_date: "Дата счета",
    late_invoices_planned_statement_date: "План. дата акта",
    late_invoices_pay_date: "Срок оплаты",
    late_invoices_contract_name: "Номер договора",
    late_invoices_max_pay_date: "Дата возникновения задолженности",
    late_invoices_expected_pay_date: "План. дата оплаты",
    late_invoices_date_send_closed_docs: "Дата отправки закрывающих документов",
    late_invoices_date_sent_invoice_to_customer: "Дата отправки счета клиенту",
    late_invoices_statement_number: "Номер акта",
    late_invoices_statement_date: "Дата акта",
    late_invoices_sum_late_all: "ПДЗ",
    late_invoices_sum_without_late: "Сумма без просрочки",
    late_invoices_less_14_days: "< 14 дней",
    late_invoices_less_30_days: "< 30 дней",
    late_invoices_less_45_days: "< 45 дней",
    late_invoices_less_60_days: "< 60 дней",
    late_invoices_less_90_days: "< 90 дней",
    late_invoices_less_120_days: "< 120 дней",
    late_invoices_less_180_days: "< 180 дней",
    late_invoices_less_365_days: "< 365 дней",
    late_invoices_more_365_days: "> 365 дней",
    late_invoices_total: "Всего",
    late_invoices_lated: "Просроченная",
    user_is_not_manager:
        "Пользователь {= name } не является менеджером данного контрагента.<br>Пожалуйста, установите чекбокс слева от имени пользователя",
    broker_contract: "контракт агента",
    import_document_update_current_rows_question:
        "Обновить существующие позиции? (да - новые не будут созданы, отмена - будут созданы новые)",
    order_docs_email_need_select_docs: "Не выбраны документы для отправки в колонке \"Отправить\"",
    order_docs_email_send: "Отправить",
    order_docs_email_send_logic_1: "Рассылка 1",
    order_docs_email_send_logic_2: "Рассылка 2",
    order_docs_email_need_doc_type: "Не выбран тип документа",
    order_docs_email_need_gtd_file: "Должен быть прикреплен файл, название которого - номер дт(21 цифра).",
    ztm_invalid_order: "Заказ не соответствует статусу \"Новый\":",
    cannot_remove_part_number_with_invoices: "Нельзя удалить инвойс, по которому выставлены счета",
    order_profit_by_oper_type_by_year__number_by_client: "Референс",
    order_profit_by_oper_type_by_year__order_number: "Номер заказа",
    order_profit_by_oper_type_by_year__cbx_date: "Дата прибытия на свх/терминал",
    packing_task_quantity: "Кол-во",
    pk_card: "ПК",
    payments_by_bank__profits: "Прибыли",
    payments_by_bank__spends: "Убытки",
    payments_by_bank__unknown_value: "(Не задано)",
    payments_by_bank__no_name: "(Без названия)",
    payments_by_bank__total: "Итого",
    payments_by_bank__main_total: "Общий итог",
    payments_by_bank__rate_type: "Статья",
    do_you_wanna_run_all_business_processes: "Запустить все бизнес-процессы?",
    tp_els__duty_pay: "Платежи Пошлина",
    tp_els__prepay: "Платежи Аванс",
    tp_els__payments_other_taxes: "Платежи Прочие пошлины",
    tp_els__duty_remains: "Остаток Пошлина",
    tp_els__remains_prepay: "Остаток Аванс",
    tp_els__remains_other_taxes: "Остаток Прочие пошлины",
    tp_els__liq_duty: "Ликвидность Пошлина",
    tp_els__liq_prepay: "Ликвидность Аванс",
    tp_els__liq_other_taxes: "Ликвидность Прочие пошлины",
    tp_els__pays: "Платежи",
    tp_els__remains: "Остаток",
    tp_els__liq: "Ликвидность",
    tp_els__other_taxes: "Прочие пошлины",
    tp_els__pk_card: "таможенная карта",
    form_error__permissions_denied: "У вас не достаточно прав",
    form_error__deleted_object: "Объект удален",
    close_all_noty: "Закрыть все",
    waybill: "ТТН",
    cell_editor_permission_denied: "Нет прав доступа",
    role_form_menu: "Меню",
    role_form_settings: "Настройки",
    import_payment_file_result:
        "Загружено {= total } выписок.\nСоздано {= incomingCount } полученных ПП.\nСоздано {= outgoingCount } отправленных ПП.\nУже существовало {= existCount } ПП.",
    has_archive_units: "Обнаружены грузы находящиеся в архиве с id : {= units }",
    has_duplicate_category: "Обнаружены повторяющиеся категории : {= names }",
    ztm_invalid_values: "Неправильно заполнены поля: ",
    unit_has_no_exped: "У груза нет операции Экспедирование",
    unit_has_no_sea: "У груза нет Морской операции",
    operation_is_not_chosen: "Пожалуйста, выберите операцию",
    order_units_by_year__gross_weight: "Вес груза",
    order_units_by_year__quantity: "Количество мест",
    order_units_by_year__fin_oper_sum_buy_without_vat: "Расходы план",
    order_units_by_year__inv_pos_sum_buy_without_vat: "Расходы факт",
    order_units_by_year__fin_oper_sum_sale_without_vat: "Выручка план",
    order_units_by_year__inv_pos_sum_sale_without_vat: "Выручка факт",
    order_units_by_year__profitability: "Рентабельность %",
    order_units_by_year__sys_serial_number: "Номер заказа",
    cannot_save_if_day_start_is_more_than_day_end:
        "Ошибка! День окончания не может быть меньше дня начала.<br>Исключение: если Вы хотите указать, что данная ставка действует во все последующие дни, то поставьте в качестве значения 'Дня окончания' ноль (0).",
    cannot_save_if_date_start_is_more_than_date_end:
        "Ошибка!<br>Дата окончания действия ставки не может быть раньше даты начала действия ставки.",
    port_terminal: "Портовый терминал",
    container_terminal: "Контейнерный терминал",
    contract_type_agent: "Агентский",
    forbidden_to_edit: "Запрещено редактирование",
    cannot_edit_treasury_value: "Запрещено редактировать сумму, полученную из трежери",
    forbidden_to_edit_ghq_activity: "Столбец 'GHQ Activity' редактировать запрещено",
    forbidden_to_edit_sum_payment: "Столбец “Сумма оплаты“ редактировать запрещено",
    rates_of_buy: "Котировки для покупок",
    dont_copy: "Запрещено копирование",
    sarmant_yug: "ооо \"сармант-юг\"",
    check_the_vat_type_and_rate: "Проверьте корректность типа и ставки НДС",
    appoint_assistants: "Назначить ассистентов по заказам",
    delete_assistants: "Снять ассистентов по заказам",
    appoint_managers: "Назначить менеджеров по контрагентам",
    delete_managers: "Снять менеджеров по контрагентам",
    appoint_roles: "Назначить роли",
    delete_roles: "Снять роли",
    appoint_employees: "Назначить сотрудников по счетам",
    delete_employees: "Снять сотрудников по счетам",
    date_start_more_date_end: "Ошибка! Дата окончания не может быть меньше даты начала.",
    one_of_the_three_companies_should_be_chosen: "Необходимо выбрать одну из трех компаний",
    order_units_by_year_direction__null: "Не заполнено направление",
    payload_too_large: "Выгружаемый файл слишком большой. Пожалуйста, уменьшите объем данных для выгрузки.",
    not_unique_mmsi: "Данный MMSI уже используется",
    invalid_swift: "Поле SWIFT должно содержать 8/11 символов, из которых первые 6 - буквы.",
    not_unique_swift: "Данный SWIFT уже используется",
    not_unique_bik: "Данный БИК уже используется",
    order_requests_are_copied_in_the_background:
        "Идёт копирование коммерческих предложений<br>Копирование проходит в фоновом режиме<br>и может занять некоторое время.",
    is_agency: "Агентский",
    need_agency_type_contract:
        "В счете находятся перевыставленные позиции.<br> Необходимо выбрать договор с типом «Агентский»",
    list_EDI_events: "Список событий EDI",
    table_title: "Таблица",
    broken_part_number_positions: "По некоторым позициям не была расчитана ТП Пошлина. Подробнее?",
    error_unlink_disabled:
        "Груз привязан к архивному заказу, либо к заказу, у которого Покупки занесены или Ставки проверены",
    cant_remove_batch_fin_operation_with_invoices:
        "Нельзя удалить пакетную фин.операцию, на которую выставлены счета: {= batchFinIds }",
    date_received_is_not_same: "Даты получения разные - изменение заблокировано",
    on_order_has_not_sea_operation: "На заказе отсутствует Морская операция",
    clients_list_text: "Клиенты",
    containers: "Номера грузовых единиц",
    invoice_doc_number: "Номер счета",
    orders_numbers: "Заказы",
    orders_references: "Референсы",
    rate_expense_type_names: "Номенклатуры",
    create_single_owner_unit: "Добавить экспортную перевозку",
    create_multiple_owner_unit: "Пакетное добавление экспортных перевозок",
    quantity_must_be_more_0: "Количество подвижного состава должно быть больше 0",
    invoice_positions_validation_error: "Необходимо заполнить: {= columns}",
    customers_or_suppliers_checkbox: "Необходимо указать роли контрагентов",
    counterparty_balance_report: "Баланс с контрагентами",
    cost_price_report: "Себестоимость",
    article_report: "Отчет по артикулам",
    on_order_has_not_feeder: "На заказе отсутствует Фидерный коносамент",
    empty_invoce_statement_number_or_date_error: "В заказе присутствует счет без номера и/или даты акта",
    calc_storage_rates__required_fields_error:
        "Необходимо заполнить поля: <br/> {= datePortIncoming}{= datePortOutgoing}{= dateReturnEmpty}{= companySeaLineId}{= unitTypeId} ",
    datePortIncoming: "Дата прибытия,",
    datePortOutgoing: "&nbsp;Дата вывоза,",
    dateReturnEmpty: "&nbsp;Дата сдачи контейнера,",
    companySeaLineId: "&nbsp;Линия,",
    unitTypeId: "&nbsp;Тип грузовой единицы&nbsp;",
    calc_storage_rates__required_fields_error2:
        "Необходимо заполнить поля: <br/> Дата прибытия, Дата вывоза, Дата сдачи контейнера, Линия, Тип грузовой единицы",
    disabled_consignment_types_are_not_allowed: "Необходимо указать тип коносамента",
    LIST_COMPANY_CATEGORY: "Категория",
    forbidden_to_inline_edit: "Строчное редактирование поля \"{= key}\" записи {= rowId} запрещено, так как {= message}.",
    forbidden_to_remove_tab_by_filter:
        "Удаление вкладок у счета {= invoiceId} запрещено, так как сработал фильтр по условию \"{= filterKey}\"",
    forbidden_to_remove_tab_by_filter_without_name:
        "Удаление вкладок у счета {= invoiceId} запрещено по фильтру",
    constrain_period_year: "Недопустимое значение поля, введите число от {= minConstrain } до {= maxConstrain }.",
    constrain_period_month: "Недопустимое значение поля, введите число от 1 до 12.",
    current_value_is_float: "Необходимо ввести целое число",
    units_numbers: "Грузовые единицы",
    cell_prevent_warner_window: "Столбец {= cell } не может быть отредактирован, т.к.{= about }.",
    billed_invoice: " на фин операцию выставлен счёт",
    checked_buy: " стоят галки “Покупки занесены”",
    id_invoice_1c_unload_type: "Cтатус выгрузки в 1С",
    statement_date_less_than_date_in_fin_settings: "Дата акта",
    remove_linked_unit: "Вы удалили связанный груз",
    the_main_organization_is: "Головной организацией является {= companyName}",
    enter_tab_name: "Введите название вкладки",
    Автомобильная: "Автомобильная",
    Авиационная: "Авиационная",
    Морская: "Морская",
    Железнодорожная: "Железнодорожная",
    "Таможенное оформление": "Таможенное оформление",
    Экспедирование: "Экспедирование",
    Перетарка: "Перетарка",
    Документальная: "Документальная",
    Иная: "Иная",
    is_closing_documents_issue: "Оформить закрывающие документы",
    "conversion_operation_required_account_91.1": "Необходимо создать счет с номером 91.1",
    "conversion_operation_required_account_91.2": "Необходимо создать счет с номером 91.2",
    has_order_completed_by_accauntant: "Наличие заказа, завершенного отделом фин службы",
    id_invoice_1c_unload_type_equals_2: "\"Cтатус выгрузки в 1C\" - \"Выгружен\"",
    statement_date_less_than_date_in_fin_settings_equals_1:
        "\"Дата акта\" меньше даты, указанной в поле \"Настройки (финансы)\"",
    has_closed_docs_equals_1: "у счета созданы закрывающие документы",
    has_1c_unload_1: "счет выгружен в 1с",
    is_closing_documents_issue_1: "у счета оформлены закрывающие документы",
    archived_order_equals_1: "нельзя редактировать счёт заказа, находящегося в архиве",
    mirror_1: "нельзя редактировать зеркальный счёт",
    is_manager_bonus_period_close_1: "нельзя редактировать счёт, если период закрыт",
    has_order_completed_by_accauntant_equals_1: "в счете есть заказ, завершенный отделом фин службы",
    sales_manager: "Менеджер по продажам",
    file_name_too_long: "Превышена допустимая длина имени файла",
    MANAGER: "Менеджер",
    has_closed_docs: "Закрывающие документы созданы/получены",
    is_mirror: "Зеркальный счёт",
    has_closed_docs_error: "Редактирование запрещено, т.к. созданы закрывающие документы",
    date_loading: "План дата забора груза",
    date_delivery: "План дата доставки груза",
    quantity_units_and_owner_plan: "Кол-во, типы, собственник грузовых единиц план",
    quantity_units_and_owner_fact: "Кол-во, типы, собственник грузовых единиц факт",
    wrong_product_error: "Нельзя редактировать Shipment Type, при выбранном Job Solution",
    reload_rates_required_fields: " {= invoiceIds} ",
    invoiceIds: "Нельзя обновить фин. операции, по которым выставлены счета ",
    need_contract_name: "Необходимо заполнить следующие элементы: Номер договора",
    need_doc_part_number: "Необходимо заполнить следующие элементы: Номер инвойса",
    order_ids_that_expenses_include: "Перевыставить счет нельзя, так как в заказе № {=orderIds} расходы учтены ",
    archived_order: "Нельзя редактировать счёт заказа, находящегося в архиве",
    fin_oper_form_add_docs: "Добавить документы",
    fin_oper_form_not_linked_unit: "Нет грузов, привязанных к данной фин. операции.",
    fin_oper_form_not_linked_order_doc: "Нет подходящих документов, привязанных к заказу данной фин. операции.",
    fin_oper_form_not_selected_order_doc: "Документы не были выбраны!",
    define_additional_control_without_forward_error:
        "Нельзя ввести параметр Доп. контроль для грузов, не имеющих операции Экспедирование",
    define_additionals_controls_if_more_than_one_error:
        "Нельзя изменять общий параметр Доп. контроль, если грузы проходят разные типы Доп. контроля",
    define_additionals_controls_if_no_unit_error:
        "Нельзя ввести параметр Доп. контроль, пока не определены экспедируемые грузы",
    multiple_default_templates_per_client: "Выбранному клиенту уже назначен шаблон лог схемы по умолчанию",
    email_contain_spaces: "Email не может содержать пробелы",
    email_contain_special_character: "Email содержит нежелательный специальный символ: < или >",
    has_biz_scope_ml: "Редактирование запрещено, т.к. выбран Biz Scope ML",
    excel_file_with_translations_required: "Для загрузки переводов в логось нужен excel-файл с переводами",
    only_for_sys_admin: "Доступно только для пользователя admin!",
    ru_system_lang_required: "Чтобы воспользоваться функционалом - переключите систему на русский язык",
    different_vats_in_fin_opers_warn: "Невозможно создать счёт, разные ставки НДС в фин. операциях",
    different_vats_when_add_fin_oper_warn: "Нельзя добавить фин операцию: не совпадает ставка НДС",
    different_inv_pos_vats_when_add_fin_oper_warn:
        "Нельзя добавить фин операцию: не совпадают ставки НДС позиций счета",
    require_payer: "Необходимо заполнить следующий элемент: Плательщик",
    documents_without_gross_weight: "Не заполнен вес по документам: {= documentsData}",
    add_FIN_OPERATION_ORDER_DOC_LINK: "Добавить документы фин операции",
    add_order_FIN_OPERATION_ORDER_DOC_LINK: "Добавить документы фин. операции данного заказа",
    vat_column: "Ставка НДС",
    vat_type_column: "Тип НДС",
    balance_with_counterparty_category: "Категория",
    balance_with_counterparty_manager: "Менеджер",
    balance_with_counterparty_counterparty: "Контрагент",
    balance_with_counterparty_order: "Заказ",
    balance_with_counterparty_document: "Документ",
    balance_with_counterparty_rate_expense_type: "Номенклатура",
    financial_result_report: "Финансовый результат",
    year: "Год",
    interval_type_day: "День",
    interval_type_week: "Неделя",
    interval_type_month: "Месяц",
    warning_forbidden_to_edit_rec_with_linked_closed_period:
        "Невозможно изменить запись, она относится к премии с закрытым периодом",
    is_manager_bonus_period_close: "Поставлена галка \"Период закрыт\"",
    incoming: "Полученные",
    outgoing: "Отправленные",
    diffCurs: "Разные курсы позиций счета для фин.операции: {=finOperationId}",
    diffCurrency: "Разные валюты позиций счета для фин.операции: {=finOperationId}",
    error_edition_railway_points: "Изменение этой ячейки ограничено",
    duplicate_invoice_found: "Обнаружены дубликаты счета",
    no_value: "(Не указано)",
    wrong_doc_date: "Неверная дата счета",
    not_rights_see_orders_and_units: "Отсутствуют права доступа",
    user_operation_name: "Оперативный менеджер",
    commission_percent_is_not_create: "Не заполнена 'Комиссия за перевыставление' в договоре или приложении к договору",
    nomenclature_for_renomination_is_not_filled: "Номенклатура для перевыставления не выбрана",
    access_denied: "Доступ запрещён",
    date_type_doc_date: "Дата счета",
    date_type_planned_statement_date: "Плановая дата акта",
    list_tnved_code: "Код ТНВЭД",
    volume: "Объем груза",
    danger_class_un_number: "Класс опасности, UN Number",
    country_start_name: "Страна забора",
    country_start_name_eng: "Страна забора (англ)",
    country_end_name: "Страна доставки",
    country_end_name_eng: "Страна доставки (англ)",
    units_temperature_mode_agg: "Температурный режим",
    point_start_address_eng: "Адрес места забора груза (англ)",
    point_end_address_eng: "Адрес места доставки груза (англ)",
    point_gtd_name_eng: "Место подачи ДТ (англ)",
    point_gtd_name: "Место подачи ДТ",
    place_dimensions: "Габариты одного места",
    unit_type_plan: "Тип контейнера",
    quantity_plan: "Кол-во контейнеров (потенциальный объем)",
    company_principal_name: "Принципал",
    note: "Примечание",
    excel_download_error: "Ошибка выгрузки Excel",
    logos_logout: "Произведен выход из Логоса",
    WEEK_DAY_SUN: "Воскресенье",
    WEEK_DAY_MON: "Понедельник",
    WEEK_DAY_TUE: "Вторник",
    WEEK_DAY_WED: "Среда",
    WEEK_DAY_THU: "Четверг",
    WEEK_DAY_FRI: "Пятница",
    WEEK_DAY_SAT: "Суббота",
    seconds: "секунд",
    copy_title: "Копировать название",
    show_logs_on_time: "Перейти ко всем логам в это время",
    filter_by_that_value: "Фильтровать по этому значению",
    ignore_that_value: "Убрать из выборки это значение",
    inspect_cell: "Инспектировать ячейку",
    prefix_for_build_stimulsoft_name: "от",
    our_company: "Наша фирма",
    space_letter: "Символ пробела",
    show_logs_on_this_time: "Показать логи",
    show_data_changes_logs_on_this_time: "Показать журнал измнеений",
    forwarding_service_report: "Отчет по результатам работы ТЭО"
};
